import { Marker, Popup } from "react-leaflet";
import { memo, useMemo } from "react";
import { sensorMarkerIcon } from "../../assets/icons/sensorMarkerIcons";
import MapPopupTable from "../MapPopupTable/MapPopupTable";

const DRONE_ICON = sensorMarkerIcon("#248cc5");

const DroneMarker = memo(({ packet }: { packet: any }) => {  
  const position = useMemo(
    () => [packet.geometry.coordinates[1], packet.geometry.coordinates[0]] as [number, number],
    [packet.geometry.coordinates[1], packet.geometry.coordinates[0]]
  );

  return (
    <Marker position={position} icon={DRONE_ICON}>
      <Popup
        className="custom-popup"
        autoClose={false}
      >
        <MapPopupTable properties={packet.properties}/>
      </Popup>
    </Marker>
  );
});

export default DroneMarker;